/* eslint-disable */
import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  container: {
    flexDirection: 'row',
    // alignItems: 'center',
    // justifyContent: `space-between`
  },
  button : {
    flexDirection: 'row',
    // width : 40 ,
    height: 40,
   alignItems: `center`,
   justifyContent: `center`
  },
  text : {
    fontSize: 12,
    marginLeft: 5
  }
})
